import React from 'react';

import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import BaseUnifiedThreatPrevention from '../../AbstractObjects/GatewayPlan/InnerPages/BaseUnifiedThreatPrevention';

const pageSchema = GatewayGetSchema.pages.unifiedThreatPrevention;
const pageId = pageSchema.pageId;

function PlanUnifiedThreatPrevention({
    planObject,
    setPlanData,
    setEditorPageId
}) {
    let pageData = planObject[pageId];

    return (
        <BaseUnifiedThreatPrevention
            pageData={pageData}
            setObjectData={setPlanData}
            setEditorPageId={setEditorPageId}
        />
    );
}

export default PlanUnifiedThreatPrevention;